import React, {Fragment} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import cx from "classnames";

class TagEdit extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            formData: {...props.tagData} || {}
        }
    }

    handleChange = (e) => {
        let { formData } = this.state;
        let name = e.target.name;
        formData[name] = e.target.value;
        this.setState({formData});
    }

    submitForm = (e) => {
        e.preventDefault();
        let { formData } = this.state;
        this.props.onSave(formData);
    }

    render(){

        let { showModal, oncancel, formId } = this.props;
        let { formData } = this.state;

        let header = 'Add Tag';
        let btnText = 'Add Tag';

        if(formId !== undefined && formId !== '' && formId != null){
            header = 'Update Tag';
            btnText = 'Update Tag';
        }

        return (
            <Fragment>
                <Modal size={'md'} isOpen={showModal}  toggle={oncancel} >
                    <form name={'tag'} onSubmit={(e) =>{return this.submitForm(e)}}>
                        <ModalHeader toggle={oncancel}>
                            {header}
                        </ModalHeader>
                        <ModalBody>
                            <div>
                                <div className={`mb-3`}>
                                    <label className={''} htmlFor="tag_name">{`Name`}</label>
                                    <input
                                        required={true}
                                        value={formData['Name'] !== undefined ? formData['Name'] : ''}
                                        onChange={(e) => {this.handleChange(e)}}
                                        name={'Name'}
                                        type={'text'}
                                        className={cx('form-control')}
                                        autoComplete={'off'}
                                    />
                                </div>
                                <div className={`mb-3`}>
                                    <label className={''} htmlFor="tag_description">{`Description`}</label>
                                    <textarea
                                        name="Description"
                                        value={formData['Description'] !== undefined ? formData['Description'] : ''}
                                        onChange={(e) => {this.handleChange(e)}}
                                        className={`form-control tag-description`}
                                        autoComplete={"off"}
                                        placeholder={""}
                                    />
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button className={`le-button lePrimaryBtn br-4`} color="primary" type={'submit'}>
                                {btnText}
                            </Button>
                        </ModalFooter>
                    </form>
                </Modal>
            </Fragment>
        );


    }
}

export default TagEdit;